export default (theme) => ({
    // lightgreyBackground: {
    //     backgroundColor: "lightgrey",
    // },
    darkBorderTop: {
        borderTop: "2px solid black",
    },
    // lightBorderLeft: {
    //     borderLeft: "2px solid #bababa",
    // },
});
